// removed by extract-text-webpack-plugin
module.exports = {"topWrapper":"src-layouts----layout-module---topWrapper---2TDeW","header":"src-layouts----layout-module---header---2JHpi","headerInner":"src-layouts----layout-module---headerInner---2t9ZS src-styles----global---centredContainer---3bAlq","title":"src-layouts----layout-module---title---2klHM","strapline":"src-layouts----layout-module---strapline---1un8k","container":"src-layouts----layout-module---container---3LcPI src-styles----global---centredContainer---3bAlq"};


//////////////////
// WEBPACK FOOTER
// ./src/layouts/layout.module.scss
// module id = 274
// module chunks = 114276838955818